import React from 'react';
import { siteConfig } from '../../data/siteConfig';
import Gallery from '../../components/Gallery/Gallery';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        {/* Header */}
        <div className="about__header">
          <h1 className="about__title">About Golden Pour</h1>
          <p className="about__subtitle">
            {siteConfig.brand.description}
          </p>
        </div>

        {/* Story Section */}
        <section className="about__section">
          <div className="content-grid">
            <div className="content-text">
              <h2>Our Story</h2>
              <p>
                Golden Pour is more than just a bar – it's a celebration of Victoria's 
                thriving craft beer scene. We're passionate about supporting local breweries 
                and bringing you the freshest, most innovative beers from across our beautiful state.
              </p>
              <p>
                Located in the heart of Keilor East, our venue offers a warm, welcoming 
                atmosphere where beer enthusiasts, families, and locals can come together 
                to enjoy exceptional drinks and great company.
              </p>
            </div>
          </div>
        </section>

        {/* Philosophy Section */}
        <section className="about__section">
          <div className="content-grid">
            <div className="content-text">
              <h2>Our Philosophy</h2>
              <div className="philosophy-points">
                <div className="philosophy-point">
                  <h3>🍺 Rotating Excellence</h3>
                  <p>
                    Our 12 rotating taps ensure there's always something new to discover. 
                    From hoppy IPAs to smooth stouts, crisp lagers to refreshing ciders, 
                    we carefully curate our selection to showcase the best of Victorian brewing.
                  </p>
                </div>
                
                <div className="philosophy-point">
                  <h3>🌾 Local First</h3>
                  <p>
                    We believe in supporting our local brewing community. Every tap features 
                    beers from Victorian breweries, helping to sustain and grow our state's 
                    incredible craft beer industry.
                  </p>
                </div>
                
                <div className="philosophy-point">
                  <h3>🥘 BYO Food Welcome</h3>
                  <p>
                    Bring your favorite meal from home or order from nearby restaurants. 
                    We believe great beer pairs perfectly with your favorite food, 
                    creating a relaxed, home-away-from-home experience.
                  </p>
                </div>
                
                <div className="philosophy-point">
                  <h3>👨‍👩‍👧‍👦 Family Friendly</h3>
                  <p>
                    Golden Pour welcomes everyone – families with children, groups of friends, 
                    couples on date night, and solo visitors looking for a quiet beer. 
                    Our atmosphere is calm, mature, and inclusive.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section className="about__section">
          <div className="content-grid">
            <div className="content-text">
              <h2>The Golden Pour Experience</h2>
              <p>
                Step into our thoughtfully designed space and you'll immediately feel 
                the difference. Warm lighting, comfortable seating, and carefully curated 
                music create an atmosphere that's both sophisticated and relaxed.
              </p>
              <p>
                Whether you're unwinding after work, catching up with friends, or 
                exploring new beer styles, our knowledgeable staff are here to help 
                you find the perfect pour. We're not just serving beer – we're creating 
                moments of connection and discovery.
              </p>
              
              <div className="features-list">
                <div className="feature-item">
                  <span className="feature-number">{siteConfig.features.tapsCount}</span>
                  <span className="feature-text">Rotating Craft Beer Taps</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">🏠</span>
                  <span className="feature-text">BYO Food Policy</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">🌟</span>
                  <span className="feature-text">Premium Atmosphere</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">👨‍👩‍👧‍👦</span>
                  <span className="feature-text">Family Friendly</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="about__section">
          <h2 className="section-title">Our Space</h2>
          <p className="section-subtitle">
            Take a look inside Golden Pour and get a feel for our warm, 
            welcoming atmosphere.
          </p>
          <Gallery />
        </section>

        {/* Visit Section */}
        <section className="about__section">
          <div className="visit-info">
            <h2>Visit Us</h2>
            <p>
              We're currently putting the finishing touches on our space and 
              will be opening soon. Follow our journey and be the first to know 
              when we're ready to pour your first beer.
            </p>
            
            <div className="visit-details">
              <div className="detail-item">
                <h4>Location</h4>
                <p>{siteConfig.contact.address.full}</p>
              </div>
              
              <div className="detail-item">
                <h4>Opening Status</h4>
                <p className="status-opening">{siteConfig.hours.message}</p>
              </div>
              
              <div className="detail-item">
                <h4>What to Expect</h4>
                <p>
                  Premium Victorian craft beers, relaxed atmosphere, 
                  BYO food welcome, family-friendly environment
                </p>
              </div>
            </div>

            <div className="cta-section">
              <p>Ready to explore our beer selection?</p>
              <a href="/menu" className="btn btn-primary btn-lg">
                View The Pourboard
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;